import { useCallback, useEffect, useState } from 'react'
import { prop } from 'ramda'

import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { DataBox, subscibeTo } from 'app/common/data-box-store'
import { sortClasses } from 'app/common/lib/sort'
import {
  defaultSchoolYearDataReceiver,
  defaultSchoolYearSelection,
  orgsFilterSelection,
  schoolYearFilter,
  schoolYearFilterSelection,
} from 'app/dataProviders/filter-items'
import { ItemType } from 'app/common/ui-next/plain-selector'

type Props = {
  id: string
  pending: boolean
}

const sortByTitle = sortClasses<{ title: string }>('up', prop('title'))

const schoolYearFilterForSelector = schoolYearFilter

export const SchoolYearFilter = ({ id, pending }: Props) => {
  const [isOrgReady, setOrgReady] = useState<boolean>(false)

  const handleOrgsFilter = useCallback((data: string[]) => {
    if (data.length === 1 && data[0] !== 'empty') {
      schoolYearFilterSelection.resetToDefault()
      schoolYearFilter.addDataReceiver(defaultSchoolYearDataReceiver)
      schoolYearFilter.dataReceive()
      setOrgReady(true)
      return
    }
    schoolYearFilter.resetToDefault()
    schoolYearFilterSelection.setDefault([])
    setOrgReady(false)
  }, [])

  useEffect(() => {
    const orgsUnsubsribe = subscibeTo<string[]>(orgsFilterSelection.id, handleOrgsFilter)

    return () => {
      orgsUnsubsribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    isOrgReady && (
      <PlainItemsSelectorBox
        id={id}
        label="Учебный год"
        header="Выбор учебного года"
        dataBoxData={
          schoolYearFilterForSelector as DataBox<Array<unknown>> as DataBox<Array<ItemType>>
        }
        dataBoxSelection={schoolYearFilterSelection}
        pleaseSelectText="Нет данных"
        selectedAllOnEmptySelection
        disabled={pending}
        sortFunc={sortByTitle}
        defaultSelection={defaultSchoolYearSelection}
        emptyTitle="Нет данных"
      />
    )
  )
}
